/* Completa tu equipo — cross-sell dentro de la ficha (Gradivus / transversal)

   Tres caminos llevan los accesorios al carro y ninguno pelea con el tema:
   1. El boton propio del bloque: agrega producto principal + marcados de una vez.
   2. El boton grande del tema: agrega AJAX por su cuenta y dispara
      'ajaxProduct:added'. Ahi recien mandamos los accesorios, sin interceptar
      su submit ni arriesgar el camino de compra.
   3. La barra flotante: lee window.FilmeezyAddons y los suma a su propia llamada.
*/
(function () {
  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  }

  var bloques = [];

  function normalizar(t) {
    return (t == null ? '' : String(t)).toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ').trim();
  }

  // Candidatos de color a partir de la variante elegida. Se descartan tallas y
  // onzas: "M" o "S" calzan con cualquier texto y terminarian eligiendo mal.
  // Se prueba el valor completo y tambien su primera palabra, porque el
  // producto puede ser "Azul con negro" y la venda simplemente "Azul".
  function candidatosColor(opciones) {
    var out = [];
    (opciones || []).forEach(function (valor) {
      var n = normalizar(valor);
      if (n.length < 4) return;
      if (/^[0-9]+\s?(oz|onz|kg|cm|mt|m)\b/.test(n)) return;
      out.push(n);
      var primera = n.split(' ')[0];
      if (primera.length >= 4 && primera !== n) out.push(primera);
    });
    return out.sort(function (a, b) { return b.length - a.length; });
  }

  function init(caja) {
    if (caja.dataset.listo === 'true') return;
    caja.dataset.listo = 'true';

    var items = Array.prototype.slice.call(caja.querySelectorAll('.pdp-addons__item'));
    var boton = caja.querySelector('[data-addons-agregar]');
    var totalEl = caja.querySelector('[data-addons-total]');
    var mainVariant = caja.dataset.mainVariant || '';
    var mainPrice = parseInt(caja.dataset.mainPrice, 10) || 0;

    // Cada fila: la casilla manda, el select solo cambia cual variante entra
    items.forEach(function (item) {
      var check = item.querySelector('[data-addon-check]');
      var select = item.querySelector('[data-addon-variante]');
      var precioEl = item.querySelector('[data-addon-precio]');
      var antesEl = item.querySelector('[data-addon-antes]');
      var fotoEl = item.querySelector('[data-addon-foto]');

      if (select) {
        // 'input' solo lo dispara la persona; el match automatico usa 'change'
        select.addEventListener('input', function () { select.dataset.tocado = 'true'; });

        select.addEventListener('change', function () {
          var op = select.options[select.selectedIndex];
          if (!op) return;
          check.dataset.variante = op.value;
          check.dataset.precio = op.dataset.precio || check.dataset.precio;
          if (precioEl) precioEl.textContent = money(parseInt(check.dataset.precio, 10) || 0);
          if (antesEl && op.dataset.antes) antesEl.textContent = money(parseInt(op.dataset.antes, 10) || 0);

          // Si elige la venda roja, tiene que ver la roja
          if (fotoEl && op.dataset.foto) fotoEl.src = op.dataset.foto;

          recalcular();
        });
      }

      if (check) check.addEventListener('change', recalcular);
    });

    function seleccionados() {
      return items
        .map(function (item) { return item.querySelector('[data-addon-check]'); })
        .filter(function (c) { return c && c.checked && c.dataset.variante; })
        .map(function (c) {
          return { id: c.dataset.variante, quantity: 1, precio: parseInt(c.dataset.precio, 10) || 0 };
        });
    }

    function recalcular() {
      var extras = seleccionados();
      var suma = extras.reduce(function (t, e) { return t + e.precio; }, 0);

      caja.classList.toggle('pdp-addons--con-seleccion', extras.length > 0);
      if (totalEl) totalEl.textContent = money(mainPrice + suma);
    }

    // Hace calzar el color del accesorio con el del producto principal, salvo
    // que la persona ya haya elegido uno a mano en esa fila.
    function aplicarColor(lista) {
      if (!lista.length) return;

      items.forEach(function (item) {
        var select = item.querySelector('[data-addon-variante]');
        if (!select || select.dataset.tocado === 'true') return;

        for (var i = 0; i < lista.length; i++) {
          var calce = null;
          for (var j = 0; j < select.options.length; j++) {
            if (normalizar(select.options[j].textContent).indexOf(lista[i]) !== -1) {
              calce = select.options[j];
              break;
            }
          }
          if (calce) {
            if (select.value !== calce.value) {
              select.value = calce.value;
              select.dispatchEvent(new Event('change'));
            }
            return;
          }
        }
      });
    }

    function abrirCarro() {
      if (document.querySelector('#CartDrawer')) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      } else {
        window.location.href = '/cart';
      }
    }

    function agregar(lista, incluirPrincipal) {
      var payload = lista.map(function (e) { return { id: e.id, quantity: e.quantity }; });
      if (incluirPrincipal && mainVariant) payload.unshift({ id: mainVariant, quantity: 1 });
      if (!payload.length) return Promise.resolve();

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: payload })
      }).then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return r.json();
      });
    }

    if (boton) {
      boton.addEventListener('click', function () {
        boton.disabled = true;
        boton.classList.add('is-cargando');

        agregar(seleccionados(), true)
          .then(function () {
            boton.disabled = false;
            boton.classList.remove('is-cargando');
            limpiar();
            abrirCarro();
          })
          .catch(function (e) {
            boton.disabled = false;
            boton.classList.remove('is-cargando');
            console.warn('[addons] no pude agregar, voy al carro.', e);
            window.location.href = '/cart';
          });
      });
    }

    function limpiar() {
      items.forEach(function (item) {
        var c = item.querySelector('[data-addon-check]');
        if (c) c.checked = false;
      });
      recalcular();
    }

    // El boton grande del tema ya agrego el principal: mandamos los extras detras
    document.addEventListener('ajaxProduct:added', function () {
      var extras = seleccionados();
      if (!extras.length) return;

      agregar(extras, false)
        .then(function () {
          limpiar();
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(function (e) { console.warn('[addons] extras no entraron.', e); });
    });

    document.addEventListener('variant:change', function (evt) {
      var v = evt.detail && evt.detail.variant;
      if (!v) return;
      mainVariant = String(v.id);
      mainPrice = theme.cyberPrecio ? theme.cyberPrecio(v.price) : v.price;
      aplicarColor(candidatosColor(v.options));
      recalcular();
    });

    bloques.push({ seleccionados: seleccionados, limpiar: limpiar });
    aplicarColor(candidatosColor((caja.dataset.mainOptions || '').split('~')));
    recalcular();
  }

  // API para la barra flotante: suma los accesorios a su propia llamada
  window.FilmeezyAddons = {
    seleccionados: function () {
      return bloques.reduce(function (acc, b) {
        return acc.concat(b.seleccionados().map(function (e) {
          return { id: e.id, quantity: e.quantity };
        }));
      }, []);
    },
    limpiar: function () { bloques.forEach(function (b) { b.limpiar(); }); }
  };

  function initAll() { document.querySelectorAll('[data-addons]').forEach(init); }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
